import { combineReducers } from 'redux';

import assetList from './assetList/reducer';

export default combineReducers({ assetList });
